// Formatação partilhada (pt-PT).
export const fmt = (v?: number): string =>
  new Intl.NumberFormat("pt-PT", { style: "currency", currency: "EUR" }).format(v ?? 0);

export const fmtDate = (d?: string): string => {
  try {
    return d ? new Date(d).toLocaleDateString("pt-PT") : "—";
  } catch {
    return d || "—";
  }
};

export const pct = (v?: number): string => `${Math.round((v ?? 0) * 100)}%`;
